// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveGeneralEducationDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import GeneralEducationDTO from '../models/GeneralEducationDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    generalEducationId: number;
    generalEducation: GeneralEducationDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            generalEducationId: 0,
            generalEducation: null,
        },
        initValues);
    },
    generalEducationId: 'generalEducationId',
    generalEducation: 'generalEducation',
}

interface Result extends ResultDTO {
    generalEducation: GeneralEducationDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            generalEducation: null,
        },
        initValues);
    },
    generalEducation: 'generalEducation',
}

export { Request, Result };